import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSimpleShipping } from '../../hooks/queries/usePharmacyFeatures';

/**
 * PRX-16 — the one-page Shipping flow REPLACES Ready to Ship and Staging, so
 * this gate runs in both directions: `requires="on"` guards
 * `/order-fulfillment/shipping`, `requires="off"` guards
 * `/order-fulfillment/ready-to-ship` and `/staging-area`. Replacing rather than
 * adding is deliberate (spec 4c): with all three reachable, a bag could be
 * closed on Ready to Ship and signed out on Staging.
 *
 * While the flags load it shows the neutral spinner ClinicModuleRoute uses,
 * rather than bouncing the user off a page that is about to exist. The
 * server-side twin is `PharmacyModuleGuard`, which 404s the two Shipping
 * endpoints for the same pharmacies (ADR-057).
 */
export const SimpleShippingRoute: React.FC<{
  requires: 'on' | 'off';
  children: React.ReactNode;
}> = ({ requires, children }) => {
  const { enabled, loading } = useSimpleShipping();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  const allowed = requires === 'on' ? enabled : !enabled;
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
};
